export default __webpack_public_path__ + "static/GreatPlaceToWork-2abdf4c398383785cbb9ac3f96130e67.webp";